import React from 'react';
import { useTranslation } from 'react-i18next';
import LifecycleTypeTab from './LifecycleTypeTab';
import { getMovementTaskTypes, addMovementTaskType, updateMovementTaskType, deleteMovementTaskType } from '../../../../../api/Employee/lifecycleSettings';

const MovementTaskTypesTab: React.FC = () => {
  const { t } = useTranslation();

  return (
    <LifecycleTypeTab
      title={t('Movement Task Types')}
      description={t('Define task types for internal movements')}
      emptyMessage={t('No movement task types configured yet')}
      emptyIcon="ArrowRightLeft"
      addLabel={t('Add Movement Task Type')}
      editLabel={t('Edit Movement Task Type')}
      deleteLabel={t('Delete Movement Task Type')}
      nameLabel={t('Task type name')}
      namePlaceholder={t('e.g., Prepare Documentation')}
      successAddMessage={t('Movement task type added successfully')}
      successUpdateMessage={t('Movement task type updated successfully')}
      successDeleteMessage={t('Movement task type deleted successfully')}
      failAddMessage={t('Failed to save movement task type')}
      failDeleteMessage={t('Failed to delete movement task type')}
      deleteConfirmMessage={t('Are you sure you want to delete')}
      duplicateMessage={t('A movement task type with this name already exists')}
      fetchItems={getMovementTaskTypes}
      addItem={addMovementTaskType}
      updateItem={updateMovementTaskType}
      deleteItem={deleteMovementTaskType}
      testIdPrefix="movement-task-type"
    />
  );
};

export default MovementTaskTypesTab;
